import {
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import Confirm from 'src/componentes/message-box/confirm';
import http from 'src/services/httpService';
import ContentManager from 'src/componentes/content-manager';
import LucideIcon from 'src/componentes/lucide-icon';
import { capitalizeFirstLetter } from 'src/utils/string';
import errorHandler from 'src/utils/error-handler';
import useAuth from 'src/hooks/useAuth';

function Actions({
  endpoint,
  onRefresh,
  handleOpenEdit,
  item,
  viewMenu = false,
}) {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleEdit = () => handleOpenEdit(item);

  const handleDeleteConfirm = async () => {
    if (!item) return;

    try {
      await http.post(`${endpoint}/Remove`, { id: item.id });
      onRefresh && onRefresh();
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleDelete = async () => {
    ContentManager.addContent(
      <Confirm
        message={capitalizeFirstLetter(
          intl.formatMessage({ id: 'label.desejaMesmoExcluirEsseRegistro' })
        )}
        handleConfirm={handleDeleteConfirm}
      />
    );
  };

  return (
    <>
      <UncontrolledDropdown group>
        <DropdownToggle tag="a" className="nav-link p-0">
          <LucideIcon icon="EllipsisVertical" size={18} />
        </DropdownToggle>
        <DropdownMenu placement="left" container="body">
          {
            <DropdownItem eventkey="edit" onClick={() => handleEdit()}>
              <LucideIcon className="mr-2" icon="Pencil" size={16} />
              {capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'label.editar' },
                  { editar: resources.editar }
                )
              )}
            </DropdownItem>
          }
          {!viewMenu && (
            <DropdownItem onClick={handleDelete}>
              <LucideIcon className="mr-2" icon="Trash2" size={16} />
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.excluir' })
              )}
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
}

export default Actions;
